module.exports = __webpack_public_path__ + "img/41.4fd35474.svg";